import { createFileRoute } from '@tanstack/react-router';
import Privacy from '../../../administration/src/components/Apps/AppDetails/Privacy';
import { withModalOutlet } from '../-withModalOutlet';

export const Route = createFileRoute('/_secured/administration/apps/$appId/privacy')({
  component: withModalOutlet(Privacy),
});
